import { Action } from '@ngrx/store';
import { ProductsResponseOP, ProductOP } from '@cemex-core/cmx-api';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';

export enum ProductsActionTypes {
  LOAD = '[RMS Open Platform Products] Load products',
  SEARCH = '[RMS Open Platform Products] Search products',
  LOAD_COMPLETE = '[RMS Open Platform Products] Load products complete',
  RESET = '[RMS Open Platform Products] Reset',
  PCM_LOAD_PRODUCT = '[RMS Open Platform Products] PCM Load Product',
  PCM_LOAD_PRODUCT_FROM_API = '[RMS Open Platform Products] PCM Load Product From Api',
  PCM_LOAD_PRODUCT_SUCCESS = '[RMS Open Platform Products] PCM Load Product Success',
  PCM_LOAD_PRODUCT_FAILURE = '[RMS Open Platform Products] PCM Load Product Failure',
  PCM_SELECT_PRODUCT = '[RMS Open Platform Products] PCM Select Product',
}

/**
 * Starts a load of the product-list from the application's store.
 */
export class ProductsLoadAction implements Action {
  readonly type = ProductsActionTypes.LOAD;

  constructor() {}
}

/**
 * Starts a search of the available products from the application's store.
 */
export class ProductsSearchAction implements Action {
  readonly type = ProductsActionTypes.SEARCH;

  constructor(public payload: string) {}
}

/**
 * Signals the end of loading a product-list from the store.
 * The handler in the reducer uses filterUniqueProducts, so duplicates should be removed by that.
 */
export class ProductsLoadCompleteAction implements Action {
  readonly type = ProductsActionTypes.LOAD_COMPLETE;

  constructor(public payload: ProductsResponseOP) {}
}

/**
 * Wipes clean the product-list.
 */
export class ProductsResetAction implements Action {
  readonly type = ProductsActionTypes.RESET;

  constructor() {}
}

export class PCMLoadProductAction implements Action {
  readonly type = ProductsActionTypes.PCM_LOAD_PRODUCT;
  constructor(public payload: { productCode: string }) {}
}

export class PCMLoadProductFromAPIAction implements Action {
  readonly type = ProductsActionTypes.PCM_LOAD_PRODUCT_FROM_API;
  constructor(public payload: { productCode: string }) {}
}

export class PCMLoadProductSuccessAction implements Action {
  readonly type = ProductsActionTypes.PCM_LOAD_PRODUCT_SUCCESS;
  constructor(public payload: ProductOP | IProduct) {}
}

export class PCMLoadProductFailureAction implements Action {
  readonly type = ProductsActionTypes.PCM_LOAD_PRODUCT_FAILURE;
  constructor() {}
}

export class PCMSelectProductAction implements Action {
  readonly type = ProductsActionTypes.PCM_SELECT_PRODUCT;
  constructor(public payload: ProductOP) {}
}

export type ProductsActions =
  | ProductsLoadAction
  | ProductsSearchAction
  | ProductsLoadCompleteAction
  | ProductsResetAction
  | PCMLoadProductAction
  | PCMLoadProductFromAPIAction
  | PCMLoadProductSuccessAction
  | PCMLoadProductFailureAction
  | PCMSelectProductAction;
